<template>
  <section class="services-banner">
    <div class="services-banner__content">
      <h2 class="services-title">
        Disfruta de tu viaje con estos servicios complementarios.
      </h2>
      <p class="services-subtitle">
        Viaja tranquilo y seguro con nuestros servicios especiales, pensados en
        tu comodidad.
      </p>
      <div class="services-grid">
        <div
          class="service-card"
          v-for="(service, index) in services"
          :key="index"
          @click="goToQuote(index)"
        >
          <picture>
            <source media="(max-width: 600px)" :srcset="service.mobile" />
            <img :src="service.desktop" :alt="'Servicio ' + (index + 1)" />
          </picture>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ServicesBannerComp",
  data() {
    return {
      services: [
        {
          name: "BrightLine Miami, Fort Lauderdale y West Palm Beach",
          desktop: require("@/assets/images/banner_1.svg"),
          mobile: require("@/assets/images/banner_1.svg"),
        },
        {
          name: "Hotel Dreams Flora, Punta Cana",
          desktop: require("@/assets/images/banner_2.svg"),
          mobile: require("@/assets/images/banner_2.svg"),
        },
        {
          name: "Hotel Dreams Karibana, Cartagena",
          desktop: require("@/assets/images/banner_3.svg"),
          mobile: require("@/assets/images/banner_3.svg"),
        },
        {
          name: "Hotel Dreams Macao Beach, Punta Cana",
          desktop: require("@/assets/images/banner_4.svg"),
          mobile: require("@/assets/images/banner_4.svg"),
        },
      ],
    };
  },
  methods: {
    goToQuote(index) {
      const planName = this.services[index].name;
      this.$router.push({ name: "QuoteTouristPlan", params: { planName } });
    },
  },
};
</script>

<style scoped>
.services-banner {
  background-color: #def3ff; /* Azul corporativo */
  color: var(--color-acento-secundario);
  width: 100%;
  padding: 5% 0; /* Mismo espaciado vertical que el banner anterior */
}

.services-banner__content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 5%; /* Padding lateral alineado con el resto del sitio */
  text-align: center;
}

.services-title {
  font-size: 2rem;
  margin-bottom: 10px;
  font-weight: bold;
}

.services-subtitle {
  font-size: 1.1rem;
  margin-bottom: 40px;
  font-weight: normal;
  opacity: 0.9;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.service-card img {
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease;
  object-fit: cover;
  cursor: pointer;
}

.service-card img:hover {
  transform: translateY(-5px);
}

@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .services-grid {
    grid-template-columns: 1fr;
  }
  .services-title {
    font-size: 1.5rem;
  }
}
</style>
